import { IObservable, Subject } from '~/rage/utils';
import { IJobElectricianService } from './jobElectricianServiceTypes';

export class GameCircuitServiceStub implements IJobElectricianService {
	public getGameTimeCircuit(): IObservable<number> {
		return new Subject<number>(30000);
	}

	public getGameTimeWires(): IObservable<number> {
		return new Subject<number>(30000);
	}

	public getGameTimeSwitch(): IObservable<number> {
		return new Subject<number>(30000);
	}

	public async reportWin(): Promise<void> {
		console.log('GameCircuitService: reportWin');
	}

	public async reportLoss(): Promise<void> {
		console.log('GameCircuitService: reportLoss');
	}
}
